import { render, staticRenderFns } from "./StaffUserLabel.vue?vue&type=template&id=6e6bc0aa&scoped=true&"
import script from "./StaffUserLabel.vue?vue&type=script&lang=js&"
export * from "./StaffUserLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bc0aa",
  null
  
)

export default component.exports